const sizeClasses = {
  sm: "w-64",
  md: "w-112",
  fit: "w-fit max-w-[calc(250px+var(--spacing)*14)]",
};

export function FormSidebar({ children, size = "sm" }) {
  return (
    <div className={`bg-gray-100 shrink-0 ${sizeClasses[size]}`}>
      <div className="py-4 px-6 sticky top-16">
        {children}
      </div>
    </div>
  );
}
